module.exports = __webpack_public_path__ + "static/media/Airline _ Car Rental.2b67703b.png";